import React, { Component } from 'react';
import styles from './RightMenu.scss';

import About from './About/About.js';
import Gallery from './Gallery/Gallery.js';
import cn from 'classnames';

class RightMenu extends Component {
  render() {
    const {
      rows,
      sectionCells,
      data,
      building,
      client,
      sectionId,
      handleCellClick,
      selectedCellPath,
      filters,
      pavilionsFlat,
      handleFilters,
      isChessLoading,
      cells,
      objectType,
      profile,
      isTable,
    } = this.props;
    return (
      <div className={cn(styles.RightMenu, { [styles.Client]: client })}>
        <About
          data={data}
          building={building}
          client={client}
          sectionId={sectionId}
          objectType={objectType}
          profile={profile}
          isTable={isTable}
        />
        <Gallery
          handleCellClick={handleCellClick}
          sectionCells={sectionCells}
          rows={rows}
          row={selectedCellPath[0]}
          selectedCellPath={selectedCellPath}
          data={data}
          building={building}
          client={client}
          sectionId={sectionId}
          filters={filters}
          pavilionsFlat={pavilionsFlat}
          handleFilters={handleFilters}
          isChessLoading={isChessLoading}
          cells={cells}
          objectType={objectType}
          profile={profile}
          isTable={isTable}
        />
      </div>
    );
  }
}

export default RightMenu;



// WEBPACK FOOTER //
// ./src/components/Building/Chess/RightMenu/RightMenu.js